// Version : 0.0.5
// Author : VISHNU
// LastEdit : KARTHEESWARAN
// MODFIED DATA : 13-08-2025
import GSTTypeActionTypes from './gstType.types';

/** ***************** ADD GST TYPE DETAILS START *********************** */
export const addGSTTypeDetailsStart = (addData: any) => ({
	type: GSTTypeActionTypes.ADD_GST_TYPE_DETAILS_START,
	payload: addData,
});

export const addGSTTypeDetailsSuccess = (successData: any) => ({
	type: GSTTypeActionTypes.ADD_GST_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const addGSTTypeDetailsFailure = (failureData: any) => ({
	type: GSTTypeActionTypes.ADD_GST_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const addGSTTypeDetailsResponseReset = () => ({
	type: GSTTypeActionTypes.ADD_GST_TYPE_DETAILS_RESPONSE_RESET,
});

export const addGSTTypeDetailsResponseChanged = () => ({
	type: GSTTypeActionTypes.ADD_GST_TYPE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD GST TYPE DETAILS END *********************** */

/** ***************** UPDATE GST TYPE DETAILS START *********************** */
export const updateGSTTypeDetailsStart = (updateData: any) => ({
	type: GSTTypeActionTypes.UPDATE_GST_TYPE_DETAILS_START,
	payload: updateData,
});

export const updateGSTTypeDetailsSuccess = (successData: any) => ({
	type: GSTTypeActionTypes.UPDATE_GST_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const updateGSTTypeDetailsFailure = (failureData: any) => ({
	type: GSTTypeActionTypes.UPDATE_GST_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const updateGSTTypeDetailsResponseReset = () => ({
	type: GSTTypeActionTypes.UPDATE_GST_TYPE_DETAILS_RESPONSE_RESET,
});

export const updateGSTTypeDetailsResponseChanged = () => ({
	type: GSTTypeActionTypes.UPDATE_GST_TYPE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE GST TYPE DETAILS END *********************** */

/** ***************** GET GST TYPE LIST START *********************** */
export const getGSTTypeListStart = (getData: any) => ({
	type: GSTTypeActionTypes.GET_GST_TYPE_LIST_START,
	payload: getData,
});

export const getGSTTypeListSuccess = (successData: any) => ({
	type: GSTTypeActionTypes.GET_GST_TYPE_LIST_SUCCESS,
	payload: successData,
});

export const getGSTTypeListFailure = (failureData: any) => ({
	type: GSTTypeActionTypes.GET_GST_TYPE_LIST_FAILURE,
	payload: failureData,
});

export const getGSTTypeListResponseReset = () => ({
	type: GSTTypeActionTypes.GET_GST_TYPE_LIST_RESPONSE_RESET,
});

export const getGSTTypeListResponseChanged = () => ({
	type: GSTTypeActionTypes.GET_GST_TYPE_LIST_RESPONSE_CHANGED,
});
/** ***************** GET GST TYPE LIST END *********************** */

/** ***************** FETCH GST TYPE DETAILS START *********************** */
export const fetchGSTTypeDetailsStart = (addData: any) => ({
	type: GSTTypeActionTypes.FETCH_GST_TYPE_DETAILS_START,
	payload: addData,
});

export const fetchGSTTypeDetailsSuccess = (successData: any) => ({
	type: GSTTypeActionTypes.FETCH_GST_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchGSTTypeDetailsFailure = (failureData: any) => ({
	type: GSTTypeActionTypes.FETCH_GST_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchGSTTypeDetailsResponseReset = () => ({
	type: GSTTypeActionTypes.FETCH_GST_TYPE_DETAILS_RESPONSE_RESET,
});

export const fetchGSTTypeDetailsResponseChanged = () => ({
	type: GSTTypeActionTypes.FETCH_GST_TYPE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH GST TYPE DETAILS END *********************** */

/** ***************** DELETE GST TYPE DETAILS START *********************** */
export const deleteGSTTypeDetailsStart = (addData: any) => ({
	type: GSTTypeActionTypes.DELETE_GST_TYPE_DETAILS_START,
	payload: addData,
});

export const deleteGSTTypeDetailsSuccess = (successData: any) => ({
	type: GSTTypeActionTypes.DELETE_GST_TYPE_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteGSTTypeDetailsFailure = (failureData: any) => ({
	type: GSTTypeActionTypes.DELETE_GST_TYPE_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteGSTTypeDetailsResponseReset = () => ({
	type: GSTTypeActionTypes.DELETE_GST_TYPE_DETAILS_RESPONSE_RESET,
});

export const deleteGSTTypeDetailsResponseChanged = () => ({
	type: GSTTypeActionTypes.DELETE_GST_TYPE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE GST TYPE DETAILS END *********************** */
